<template>
    <DatatablePageLayout>
        <template v-slot:actionButtons>
            <button class="sk-btn sk-btn-primary rounded-lg" @click="handleCreate">
                {{ $t('apps.campaigns.form.createButton') }}
            </button>
        </template>
        <template v-slot:datatable>
            <DataTable
                :config="datatableConfig"
                :elements="resorts"
                :stripe="true"
                :draggable="false"
                :sst="true"
                :pagination="pagination"
                @action="handleAction"
                @filter="handleFilter"
            />
        </template>
    </DatatablePageLayout>
</template>

<script>

import DataTable from '@/modules/Shared/Components/table/SKDataTable.vue'
import loader from "@/modules/Shared/Mixins/loader";
import PaginationService from "@/modules/Shared/Services/PaginationService";
import DatatablePageLayout from "@/modules/Shared/Pages/DatatablePageLayout.vue";
import {unifyPaginatedResponse} from "@/modules/Shared/Helpers/apiResponseHelper";
import { v4 as uuidv4 } from 'uuid';
import sha256 from "crypto-js/sha256";
import ResortService from "@/modules/Admin/Services/ResortService";
import CountryService from "@/modules/Shared/Services/CountryService";

export default {
  name: "ResortsPage",
  components: {DatatablePageLayout, DataTable},
  mixins: [loader],
  data() {
    return {
      resorts: [],
      countries: {},
      datatableConfig: [
          { 'field' : 'id', head : this.$t('shops.id'), 'searchable' : true, 'sortable' : false},
          { 'field' : 'name', head : this.$t('shops.name'), 'searchable' : true, 'sortable' : false},
          { 'field' : 'country', head : this.$t('admin.apps.main.country'), 'searchable' : false, 'sortable' : false},
          { 'field' : 'is_ski_resort', head : this.$t('admin.resorts.is_ski_resort'), 'searchable' : false, 'sortable' : false},
          { 'field' : 'actions', 'type': 'actions', head : this.$t("geofences.geofences-messages.actions"), 'searchable' : false, 'sortable' : false }
      ],
      pagination: {},
    }
  },
  async created() {
      const countries = await unifyPaginatedResponse(CountryService.getCountries, {per_page: 30})
      this.countries = Object.fromEntries(countries.map(c => [c.id, c.name]))
      await this.getResorts({
          filters: [],
          page: 1
      })
  },
  methods: {
      async getResorts(params) {
          await this.load(async () => {
              const resorts = await ResortService.getResorts(PaginationService.parseParameters(params))
              this.resorts =  this.parseResorts(resorts.data)
              this.pagination = {
                  per_page: resorts.per_page,
                  total: resorts.total
              }
          })
      },
      async handleFilter(params) {
          await this.getResorts({
              filters: params.filters,
              page: params.page
          })
      },
      handleCreate() {
          this.$router.push({
              name: 'admin-resort-create',
              params: {
                uuid: sha256(uuidv4())
              }
          });
      },
      async handleAction(type, uuid){
          switch(type) {
              case 'edit':
                  await this.$router.push({
                      name: 'admin-resort-create',
                      params: {
                          'uuid': uuid,
                      }
                  });
                  break;
          }
      },
      parseResorts(resorts) {
          return resorts.map(resort => ({
              ...resort,
              country: this.countries[resort.country_id],
              is_ski_resort: resort.is_ski_resort ? this.$t('yes') : this.$t('no'),
              actions: [ 'edit' ]
          }))
      },
  }
};
</script>
